import { getApiUrl } from "./apiUrl";

// -------------------------------------------------------------------------------------------------------
// 1. GET CSRF TOKEN FROM DJANGO

export const getCsrfToken = async () => {
  try {
    const response = await fetch(getApiUrl("/api/csrf_token/"), {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Error fetching CSRF token");
    }

    const data = await response.json();

    return data.csrfToken;
  } catch (error) {
    console.error("CSRF fetch error:", error);
    throw error;
  }
};